import { RESET_POINT_OF_SALE_STATE } from '@dynameat/views/pointOfSale/mutationTypes';
import * as MutationTypes from './mutationTypes';

const resetData = (state) => {
  state.masterFeatureList = [];
};

const masterFeatureList = (state, payload) => {
  state.masterFeatureList = payload;
};

const masterTagList = (state, payload) => {
  state.masterTagList = payload;
};

export const mutations = {
  [RESET_POINT_OF_SALE_STATE]: resetData,
  [MutationTypes.MASTER_FEATURE_LIST_SUCCESS]: masterFeatureList,
  [MutationTypes.MASTER_TAG_LIST_SUCCESS]: masterTagList
};
